import selectLockEnabled from 'selectors/selectLockEnabled';
import { selectLockToken } from 'selectors/simple';
import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import nullBind from 'utils/functions/nullBind.util';

const getLocked = nullBind(getAnyOrNull, 'lib.locked');

const selectLocked = (state) => {
  // FIXME: the following logic should be moved into the appropriate reducer to make state inspection easy

  const locked = getLocked(state);
  const lockEnabled = selectLockEnabled(state);
  const token = selectLockToken(state);

  if (locked) {
    return true;
  }

  if (locked !== false) {
    return null;
  }

  // locked is false from this point

  return lockEnabled === true && !token;
};

// noinspection JSUnusedGlobalSymbols
export default selectLocked;
